<template>
  <div>
    <ModalDelete :package-item-id="packageItemId" />
  </div>
</template>

<script>
import ModalDelete from '@/components/PackageItem/ModalDelete.vue';

export default {
  name: 'PackageItemDelete',
  components: {
    ModalDelete,
  },
  props: {
    packageItemId: {
      type: String,
      required: true,
    },
  },
};
</script>
